import { Link as RouterLink } from 'react-router-dom';
// @mui
import { Box, Link, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
// auth
import { useAuthContext } from 'auth/useAuthContext';
// routes
import { PATH_DASHBOARD } from 'routes/paths';
// components
import { CustomAvatar } from 'components/custom-avatar';
import { convertToFormattedString } from 'utils/helper';
import { DYNAMIC_FORM_DEFAULT_KEYS } from 'utils/constants';

// ----------------------------------------------------------------------

const StyledRoot = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  gap: 12,
  padding: '8px 8px 4px',
  borderRadius: 0,
  backgroundColor: 'transparent',
}));

// ----------------------------------------------------------------------

export default function NavAccount() {
  const { user } = useAuthContext();

  return (
    <Link
      component={RouterLink}
      to={PATH_DASHBOARD.staffManagement.view(user?._id)}
      underline="none"
      color="inherit"
    >
      <StyledRoot>
        <CustomAvatar
          src={user?.profilePicture}
          alt={user[DYNAMIC_FORM_DEFAULT_KEYS.STAFF_FULL_NAME]}
          name={user[DYNAMIC_FORM_DEFAULT_KEYS.STAFF_FULL_NAME]}
          sx={{
            width: 72,
            height: 72,
            fontSize: 24,
            fontWeight: 700,
            color: 'primary.main',
            bgcolor: 'primary.lighter',
            border: (theme) => `2px solid ${theme.palette.primary.main}`,
            boxShadow: '0 4px 14px rgba(15, 23, 42, 0.12)',
          }}
        />

        <Box sx={{ minWidth: 0, textAlign: 'center' }}>
          <Typography variant="subtitle2" noWrap sx={{ fontSize: 16, fontWeight: 700, color: '#111827' }}>
            {user[DYNAMIC_FORM_DEFAULT_KEYS.STAFF_FULL_NAME]}
          </Typography>

          <Typography variant="body2" noWrap sx={{ color: '#637381', fontSize: 13 }}>
            {convertToFormattedString(user?.role)}
          </Typography>
        </Box>
      </StyledRoot>
    </Link>
  );
}
